module.exports = __webpack_public_path__ + "static/img/authorise-bg.657a24ef.png";